export default function roomUXEventListener(room) {
  return store => {
    room.addEventListeners({

    });
  }
}